<template>
    <div>
        <b-form @submit.prevent="onSubmit" id="fishform" v-if="pdfData == null">
            <div div class="mb-4">
                <b-card header="Describe your fish movements">
                <b-form-group v-for="(movement, index) in fishMovementForm" :key="index"
                    label-cols-sm="4"
                    :label="movement.label"
                    :label-for="movement.prop"
                    >
                    <b-form-input type="text" :id="movement.prop" v-model="pdfConfig.fishMovements[movement.prop]" required />
                </b-form-group>
                </b-card>
            </div>

            <div div class="mb-4">
                <b-card header="Supporting Text">
                    <b-form-group
                        label="Text 1"
                    >
                        <b-form-textarea type="text" v-model="pdfConfig.textBlocks.text1" required />
                    </b-form-group>
                    
                    <b-form-group
                        label="Text 2"
                    >
                        <b-form-textarea type="text" v-model="pdfConfig.textBlocks.text2" />
                    </b-form-group>
                    
                    <b-form-group
                        label="Text 3"
                    >
                        <b-form-textarea type="text" v-model="pdfConfig.textBlocks.text3" />
                    </b-form-group>
                </b-card>
            </div>
            
            <div div class="mb-4">
                <b-card header="Upload a logo">
                    <img id="logo" v-show="!edit && (files.length > 0 || storedLogo != null)" :src="files.length ? files[0].dataURI : storedLogo"/>
                    <div class="image-edit" v-show="files.length && edit">
                        <div class="image-edit-image" v-if="files.length">
                            <img ref="editImage" :src="files[0].dataURI" />
                        </div>
                        <div class="text-center p-4">
                            <button type="button" class="btn btn-secondary" @click.prevent="$refs.upload.clear">Cancel</button>
                            <button type="submit" class="btn btn-primary" @click.prevent="editSave">Save</button>
                        </div>
                    </div>
                    <file-upload
                        extensions="gif,jpg,jpeg,png,webp"
                        accept="image/png,image/gif,image/jpeg,image/webp"
                        name="logo-upload"
                        class="btn btn-primary"
                        :drop="!edit"
                        v-model="files"
                        @input-filter="inputFilter"
                        @input-file="inputFile"
                        ref="upload">
                        <span v-if="files.length || storedLogo != null">Change logo</span>
                        <span v-else>Upload a custom logo</span>
                    </file-upload>
                    &nbsp; 
                    <b-button v-if="files.length || storedLogo != null" variant="outline-primary" @click="removeLogo()">Remove logo</b-button>
                </b-card>
            </div>
            <div>
            <b-button variant="success" size="lg" type="submit" key="" :disabled="!canGeneratePDF">
                Generate my custom PDF
            </b-button>
            &nbsp;
            <b-button size="lg"  @click="onClear()">
                Reset to defaults
            </b-button>
            </div>
        </b-form>
        <div id="iframeContainer" style="width:100%; height: 600px;" v-if="pdfData != null">   
            <b-button @click="onClearPdf()" variant="outline-primary">
                Edit PDF
            </b-button>
            <iframe style="width:100%; height:100%;" :src="pdfData"></iframe>
        </div>
    </div>
</template>

<script>
import Cropper from 'cropperjs';
import FileUpload from 'vue-upload-component';
import Pdf from '../pdf';

const fishMovementForm = [
    {
        prop: 'movingHead',
        label: 'Moving head',
    },
    { 
        prop: 'movingTail',
        label: 'Moving tail',
    },
    {
        prop: 'movingHeadTail',
        label: 'Moving head & tail',
    },
    {
        prop: 'curlingSides',
        label: 'Curling sides',
    },
    {
        prop: 'turnsOver',
        label: 'Turns over',
    },
    {
        prop: 'motionless',
        label: 'Motionless',
    },
    {
        prop: 'curlsUpEntirely',
        label: 'Curls up entirely',
    },
];

const PDF_CONFIG_TEMPLATE = JSON.stringify({
    fishMovements: {
        movingHead: 'You KNOW fish',
        movingTail: 'Alive but do not feel',
        movingHeadTail: 'Delicious!',
        curlingSides: 'Feels pleasure but not pain',
        turnsOver: 'Undecided',
        motionless: 'You feel nothing, they feel nothing',
        curlsUpEntirely: 'Fully sentient beings',
    },
    textBlocks: {
        text1: 'Find out how you really feel about fish!',
        text2: '',
        text3: '',
    },
});

export default {
    components: {
        FileUpload,
    },
    data() {
        return {
            pdfConfig: JSON.parse(PDF_CONFIG_TEMPLATE),
            fishMovementForm: fishMovementForm,
            files: [],
            edit: false,
            cropper: false,
            pdfData: null,
            storedLogo:null,
        }
    },
    mounted() {
        this.$nextTick(function () {
            this.loadFromStorage();
        })
    },
    computed: {
        completedFishMovements() {
            // ensure all fishmovements have an answer
            return Object.entries(this.pdfConfig.fishMovements).every((movement) => movement[1].length > 0)
        },
        canGeneratePDF() {
            // @TODO which of the textblocks should be required?
            return this.completedFishMovements === true && this.pdfConfig.textBlocks.text1.length > 0;
        },
    },
    methods: {
        loadFromStorage() {
            const pdfConfig = window.localStorage.getItem('pdfConfig');
            if (pdfConfig !== null) {
                this.pdfConfig = JSON.parse(pdfConfig);
            }
            this.storedLogo = window.localStorage.getItem('logo');
        },
        saveToStorage() {
            window.localStorage.setItem('pdfConfig', JSON.stringify(this.pdfConfig));
            if (this.files[0]) {
                window.localStorage.setItem('logo_rotated', this.files[0].dataURI_rotated);
                window.localStorage.setItem('logo', this.files[0].dataURI);
            }
        },
        onSubmit() {
            this.saveToStorage();
            const pdfMaker = new Pdf(this.pdfConfig.fishMovements, this.pdfConfig.textBlocks);
            pdfMaker.setLogo2(window.localStorage.getItem('logo_rotated'));
            const pdf = pdfMaker.generate();
            pdf.getDataUrl((dataUrl) => {
                this.pdfData = dataUrl;
            });
        },
        onClear() {
            window.localStorage.removeItem('pdfConfig');
            this.pdfConfig = JSON.parse(PDF_CONFIG_TEMPLATE);
        },
        inputFile(newFile, oldFile) {
            if (newFile && !oldFile) {
                this.$nextTick(() => {
                    this.edit = true;
                });
            }
            if (!newFile && oldFile) {
                this.edit = false;
            }
        },
        inputFilter(newFile, oldFile, prevent) {
            if (newFile && !oldFile) {
                if (!/\.(gif|jpg|jpeg|png|webp)$/i.test(newFile.name)) {
                    this.alert('Your choice is not a picture');
                    return prevent();
                }
            }
            // show the image in the cropper
            if (newFile && (!oldFile || newFile.file !== oldFile.file)) {
                newFile.url = ''
                let URL = window.URL || window.webkitURL
                if (URL && URL.createObjectURL) {
                    newFile.dataURI = URL.createObjectURL(newFile.file)
                }
            }
        },
        editSave() {
            this.edit = false;
            let oldFile = this.files[0];

            this.$refs.upload.update(oldFile.id, {
                dataURI: this.cropper.getCroppedCanvas().toDataURL(oldFile.type),
                // get 180 rotated image
                dataURI_rotated: this.cropper.rotate(180).getCroppedCanvas().toDataURL(oldFile.type),
                type: oldFile.type,
                active: true,
            });
        },
        onClearPdf() {
            this.pdfData = null;
        },
        removeLogo() {
            window.localStorage.removeItem('logo');
            window.localStorage.removeItem('logo_rotated');
            this.storedLogo = null;
            this.$refs.upload.clear();
        }
    },
    watch: {
        edit(value) {
            if (value) {
                this.$nextTick(function () {
                if (!this.$refs.editImage) {
                    return;
                }
                let cropper = new Cropper(this.$refs.editImage, {
                    viewMode: 1,
                    autoCropArea: 1,
                    zoomOnWheel: false,
                })
                this.cropper = cropper;
                })
            } else {
                if (this.cropper) {
                    this.cropper.destroy();
                    this.cropper = false
                }
            }
        }
    },
}
</script>

<style>
#fishform {
    margin:1em 0em 2em;
}
label, legend { 
    color:#ea502f;
}
.avatar-upload .rounded-circle {
  width: 200px;
  height: 200px;
}
.text-center .btn {
  margin: 0 .5rem
}
.image-edit-image {
  max-width: 100%;
  max-height: 400px;
  text-align: center;
}
.image-edit-image img {
    margin:0px auto;
}
#logo {
  max-width: 100%;
  max-height: 400px;
  object-fit: contain;
  display: block; 
  margin: 0px auto;
}
.drop-active {
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  position: fixed;
  z-index: 9999;
  opacity: .6;
  text-align: center;
  background: #000;
}
.drop-active h3 {
  margin: -.5em 0 0;
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
  font-size: 40px;
  color: #fff;
  padding: 0;
}
</style>